import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Preloader.css';
import 'aos/dist/aos.css'; // Import AOS styles
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom'; //import

const router = createBrowserRouter([
  {
    path: "*", // Use "*" to match all paths and let App handle nested routing
    element: <App />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

window.onload = () => {
  const preloader = document.getElementById('preloader');
  if (preloader) {
    preloader.classList.add('hide');
  }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();